/*  MUI  */
import { Card } from '@auviknetworks/iceberg-ui';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { LinkCell, StringCell } from 'application/Shared/Components/Cells';
import {
    Header,
    ManagedTableV2ContextProvider,
    ManagedTableV2UI
} from 'application/Shared/Components/Table';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * A configuration view wrapper component.
 *
 * @returns {JSX.Element} The GlobalView component.
 */
export const GlobalConfigure = () => {
    const { t } = useTranslation();

    const settings = [
        {
            // Tag Editor
            action: t('Common.go'),
            description: t('Configure.tag_editor'),
            disabled: false,
            key: 'tag_editor_card',
            name: t('Sidebar.tag_editor'),
            page: '/globaladmin/configure/tags',
            permission: ['system_bulk_editor']
        },
        {
            // Form Builder
            action: t('Common.go'),
            description: t('Admin.FormBuilder.description'),
            disabled: false,
            key: 'formBuilder_editor_card',
            name: t('Admin.FormBuilder.title'),
            page: '/globaladmin/configure/formbuilder',
            permission: ['system_bulk_editor']
        },
        {
            // Manifest Manager
            action: t('Common.go'),
            description: t('Admin.Manifests.description'),
            disabled: false,
            key: 'manageManfiests_editor_card',
            name: t('Admin.Manifests.title'),
            page: '/globaladmin/configure/manifests',
            permission: ['super_admin', 'global_system_admin']
        }
    ];

    const columns = [
        {
            accessorKey: 'name',
            cell: StringCell,
            enableColumnFilter: false,
            enableHiding: false,
            enableSorting: false,
            header: Header,
            id: 'name',
            name: 'Common.name'
        },
        {
            accessorKey: 'description',
            cell: StringCell,
            enableColumnFilter: false,
            enableSorting: false,
            header: Header,
            id: 'description',
            name: 'Common.description'
        },
        {
            accessorKey: 'page',
            align: 'right',
            cell: LinkCell,
            enableColumnFilter: false,
            enableHiding: false,
            enableSorting: false,
            header: Header,
            id: 'page',
            meta: {
                align: 'right',
                header: { justifyContent: 'flex-end' }
            },
            name: 'Common.actions'
        }
    ];

    return (
        <>
            <PageTitle title={t('Configure.title')} />

            <ManagedTableV2ContextProvider
                columns={columns}
                getRowId="name"
                rows={settings}
                sortKey="name"
                mode="client"
                enableFiltering={false}
            >
                <Card>
                    <ManagedTableV2UI />
                </Card>
            </ManagedTableV2ContextProvider>
        </>
    );
};
